import { BaseIcon } from './base-icon.js';
import { svg } from 'lit';

/**
 * User Icon Component
 * User avatar icon - filled circle with person silhouette
 * Used for authenticated user display
 */
class UserIcon extends BaseIcon {
    getSvgAttributes() {
        return {
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: '0 0 24 24',
            fill: 'currentColor',
        };
    }

    renderIconPath() {
        return svg`
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z"
            />
        `;
    }
}

customElements.define('user-icon', UserIcon);
